import React, { useEffect, useState } from "react";
import { reduxForm, Field } from "redux-form";
import { Grid, Header, Divider, Button, Modal, Form } from "semantic-ui-react";
import { renderTextField, renderOptionField } from "../formcomponents";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import { useNavigate, useParams } from "react-router-dom";
import { userData } from "../store/userData";
import Swal from "sweetalert2";

const EMPTY_BANK_DETAILS = {
  accountHolderName: "",
  bankName: "",
  accountNumber: "",
  iban: "",
  swiftBic: "",
  branch: "",
  bankAddress: "",
  country: "",
  currency: "",
  routingNumber: "",
};

const parseBankDetails = (raw) => {
  if (!raw || typeof raw !== "string") {
    return { ...EMPTY_BANK_DETAILS };
  }
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return { ...EMPTY_BANK_DETAILS };
    }
    return {
      accountHolderName: parsed.accountHolderName || "",
      bankName: parsed.bankName || "",
      accountNumber: parsed.accountNumber || "",
      iban: parsed.iban || "",
      swiftBic: parsed.swiftBic || "",
      branch: parsed.branch || "",
      bankAddress: parsed.bankAddress || "",
      country: parsed.country || "",
      currency: parsed.currency || "",
      routingNumber: parsed.routingNumber || "",
    };
  } catch (e) {
    return { ...EMPTY_BANK_DETAILS };
  }
};

const hasBankDetails = (details) =>
  Object.values(details || {}).some((value) => String(value || "").trim() !== "");

const validate = (values) => {
  const errors = {};
  if (!values.categoryType) {
    errors.categoryType = "Required";
  }
  if (!values.categoryName) {
    errors.categoryName = "Required";
  }

  //categoryName

  return errors;
};

const InvoiceWorkNameIndiaCreate = (props) => {
  const { handleSubmit, pristine, reset, submitting, change } = props;
  const navigate = useNavigate();
  const { id, catId } = useParams();
  const userDetail = userData();
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [savedBankDetails, setSavedBankDetails] = useState({
    ...EMPTY_BANK_DETAILS,
  });
  const [initialBankDetails, setInitialBankDetails] = useState({
    ...EMPTY_BANK_DETAILS,
  });
  const [modalBankDetails, setModalBankDetails] = useState({
    ...EMPTY_BANK_DETAILS,
  });

  useEffect(() => {
    if (id !== "null") {
      if (userDetail.userRole != 1) {
        setbuttonDisable(true);
      }
      getWorkList();
    }
  }, []);
  const catogeryItems = [
    { value: 1, text: "Spend Money" },
    { value: 2, text: "Receive Money" },
    { value: 3, text: "Company List" },
  ];

  const getWorkList = () => {
    axios
      .post(BaseUrlInvoice + "/accounts/listSSCategory", {
        categoryType: catId,
      })
      .then((res) => {
        console.log("res", res.data);
        const tempData = res.data;
        const filterData = tempData.filter((item) => item.categoryId == id);
        console.log("filterData", filterData);

        initilizeData(filterData);
      })
      .catch((error) => console.log(error));
  };

  const initilizeData = (filterData) => {
    const parsedDetails = parseBankDetails(filterData[0].additionalInfo);
    setSavedBankDetails(parsedDetails);
    setInitialBankDetails(parsedDetails);
    props.initialize({
      categoryId: id,
      categoryName: filterData[0].categoryName,
      categoryType: filterData[0].categoryType,
      additionalInfo: hasBankDetails(parsedDetails)
        ? JSON.stringify(parsedDetails)
        : "",
    });
  };

  const openBankDetailsModal = () => {
    setModalBankDetails({ ...savedBankDetails });
    setBankModalOpen(true);
  };

  const closeBankDetailsModal = () => {
    setBankModalOpen(false);
  };

  const updateModalField = (field, value) => {
    setModalBankDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const saveBankDetails = () => {
    const nextDetails = { ...EMPTY_BANK_DETAILS, ...modalBankDetails };
    setSavedBankDetails(nextDetails);
    change("additionalInfo", JSON.stringify(nextDetails));
    setBankModalOpen(false);
  };

  const bankSummary = hasBankDetails(savedBankDetails)
    ? [savedBankDetails.accountHolderName, savedBankDetails.bankName]
        .filter((part) => String(part || "").trim() !== "")
        .join(" · ")
    : "";

  const sumbitForm = (values) => {
    console.log(values);
    axios
      .post(BaseUrlInvoice + "/accounts/createSSCategory", values)
      .then((res) => {
        console.log("res", res.data);
        if (res.data.errCode === 200) {
          Swal.fire({
            icon: "success",
            title: "sccess",
            text: "Created",
          });
          navigate(-1);
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response.status === "500") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "This Work Type Already Created",
          });
        }
      });
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Create Invoice Work Name (INDIA)
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Grid columns="two">
          <Grid.Row>
            {/* <Grid.Column>
              <Field
                name="categoryType"
                label="Category Type"
                options={catogeryItems}
                // onChange={(e) => setforOnChangeValue(e)}
                component={renderOptionField}
              />
            </Grid.Column> */}
            <Grid.Column>
              <Field
                name="categoryName"
                label="Item Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Form>
                <Form.Field>
                  <label>Bank Details / Additional Info</label>
                  <Button type="button" onClick={openBankDetailsModal}>
                    {hasBankDetails(savedBankDetails)
                      ? "Edit Bank Details"
                      : "Add Bank Details"}
                  </Button>
                  {bankSummary ? (
                    <div style={{ marginTop: "0.5em", color: "#666" }}>
                      {bankSummary}
                    </div>
                  ) : null}
                </Form.Field>
              </Form>
              <Field name="additionalInfo" component="input" type="hidden" />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Modal open={bankModalOpen} onClose={closeBankDetailsModal} size="small">
        <Modal.Header>Bank Details</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths="equal">
              <Form.Input
                label="Account Holder Name"
                placeholder="Account Holder Name"
                value={modalBankDetails.accountHolderName}
                onChange={(e, data) =>
                  updateModalField("accountHolderName", data.value)
                }
              />
              <Form.Input
                label="Bank Name"
                placeholder="Bank Name"
                value={modalBankDetails.bankName}
                onChange={(e, data) => updateModalField("bankName", data.value)}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                label="Account Number"
                placeholder="Account Number"
                value={modalBankDetails.accountNumber}
                onChange={(e, data) =>
                  updateModalField("accountNumber", data.value)
                }
              />
              <Form.Input
                label="IBAN"
                placeholder="IBAN"
                value={modalBankDetails.iban}
                onChange={(e, data) => updateModalField("iban", data.value)}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                label="SWIFT / BIC"
                placeholder="SWIFT / BIC"
                value={modalBankDetails.swiftBic}
                onChange={(e, data) => updateModalField("swiftBic", data.value)}
              />
              <Form.Input
                label="Branch"
                placeholder="Branch"
                value={modalBankDetails.branch}
                onChange={(e, data) => updateModalField("branch", data.value)}
              />
            </Form.Group>
            <Form.Input
              label="Bank Address"
              placeholder="Bank Address"
              value={modalBankDetails.bankAddress}
              onChange={(e, data) =>
                updateModalField("bankAddress", data.value)
              }
            />
            <Form.Group widths="equal">
              <Form.Input
                label="Country"
                placeholder="Country"
                value={modalBankDetails.country}
                onChange={(e, data) => updateModalField("country", data.value)}
              />
              <Form.Input
                label="Currency"
                placeholder="Currency"
                value={modalBankDetails.currency}
                onChange={(e, data) => updateModalField("currency", data.value)}
              />
            </Form.Group>
            <Form.Input
              label="Routing Number (optional)"
              placeholder="Routing Number"
              value={modalBankDetails.routingNumber}
              onChange={(e, data) =>
                updateModalField("routingNumber", data.value)
              }
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={closeBankDetailsModal}>Cancel</Button>
          <Button positive onClick={saveBankDetails}>
            Save
          </Button>
        </Modal.Actions>
      </Modal>
      <Divider hidden />
      <>
        {" "}
        <Button
          floated="right"
          positive
          disabled={buttonDisable}
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
              categoryType: 90087,
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={() => {
            reset();
            setSavedBankDetails({ ...initialBankDetails });
          }}
        >
          Cancel
        </Button>{" "}
      </>
    </div>
  );
};

export default reduxForm({
  form: "InvoiceWorkNameIndiaCreate",
  validate,
})(InvoiceWorkNameIndiaCreate);
